<template>
    <section>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <div class="modal-card" style="width: 1080px">
                <header class="modal-card-head">
                    <p class="modal-card-title">Editar Plazo de Declaración de un/a Académico/a</p>
                    <button type="button" class="delete" @click="$emit('close')" />
                </header>
                <section class="modal-card-body">
                    <form @submit.prevent="handleSubmit(editExtendPhaseTermAcademic)">

                        <div class="title is-5">
                            Datos de el/la Académico/a
                            <hr class="dropdown-divider" aria-role="menuitem">
                        </div>
                        <div class="columns">
                            <div class="column content">
                                <h6>Unidad:</h6>
                                <p>{{ extendPhaseTerm.academic_unit }}</p>
                            </div>

                            <div class="column content">
                                <h6>Nombre:</h6>
                                <p>{{ extendPhaseTerm.academic_name }}</p>
                            </div>

                            <div class="column content">
                                <h6>RUT:</h6>
                                <p>{{ extendPhaseTerm.academic_rut }}</p>
                            </div>
                        </div>

                        <div class="title is-5">
                            Fechas de Ampliación
                            <hr class="dropdown-divider" aria-role="menuitem">
                        </div>

                        <div class="columns mb-6">
                            <div class="column">
                                <b-field label="Fecha de Inicio *">
                                    <ValidationProvider name="Fecha de Inicio"
                                        :rules="{ start_date_before_end_date: extendPhaseTerm.end_date, required: true }"
                                        v-slot="{ errors }">
                                        <b-datepicker v-model="extendPhaseTerm.start_date" icon="calendar-alt"
                                            trap-focus locale="es-ES" editable placeholder="dd/mm/aaaa" />
                                        <span class="validation-alert">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </b-field>
                            </div>

                            <div class="column">
                                <b-field label="Fecha de Término *">
                                    <ValidationProvider name="Fecha de Término"
                                        :rules="{ end_date_not_before_start_date: extendPhaseTerm.start_date, required: true }"
                                        v-slot="{ errors }">
                                        <b-datepicker v-model="extendPhaseTerm.end_date" icon="calendar-alt" trap-focus
                                            locale="es-ES" editable placeholder="dd/mm/aaaa" />
                                        <span class="validation-alert">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </b-field>
                            </div>

                        </div>
                    </form>
                </section>
                <footer class="modal-card-foot is-flex is-justify-content-space-between">
                    <b-button label="Cerrar" @click="$emit('close')" />
                    <b-button label="Editar Ampliación de Plazo de Declaración" type="is-warning" icon-left="edit"
                        @click="confirmEditExtendPhaseTerm()" />
                </footer>
            </div>
        </ValidationObserver>
        <b-loading is-full-page v-model="isLoading" />
    </section>
</template>

<script>
import axios from 'axios';
export default {

    name: 'ModalEditExtendPhaseTermAcademic',

    props: {
        extendPhaseTerm: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            isLoading: false,
        }
    },

    async created() {
        this.extendPhaseTerm.start_date = new Date(this.extendPhaseTerm.start_date)
        this.extendPhaseTerm.end_date = new Date(this.extendPhaseTerm.end_date)
    },

    methods: {

        async confirmEditExtendPhaseTerm() {
            let valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Existe un error en uno de los campos, favor de revisar.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return;
            }

            this.$buefy.dialog.confirm({
                title: 'Editar Ampliación',
                message: `¿Está seguro de editar la Ampliación de Plazo de Declaración de el/la Académico/a?`,
                confirmText: 'Sí',
                type: 'is-warning',
                hasIcon: true,
                icon: 'exclamation-triangle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true,
                onConfirm: async () => {
                    await this.editExtendPhaseTermAcademic();
                }
            })
        },

        async editExtendPhaseTermAcademic() {
            this.isLoading = true
            await axios
                .put(`/extend_phase_terms/${this.extendPhaseTerm.id}.json`, this.extendPhaseTerm)
                .then(response => {
                    this.$buefy.dialog.alert({
                        title: 'Éxito',
                        message: `Se editó la Ampliación de Plazo de Declaración de el/la Academico/a.`,
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'check-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    this.$emit('refresh');
                    this.$emit('close');
                })
                .catch(error => {
                    let msg = error.response.data.errors ? error.response.data.errors : 'Hubo un error al editar la Ampliación de Plazo de Declaración. Intente más tarde';
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: msg,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }

}
</script>